import { render } from "./index.vue?vue&type=template&id=8e3aacd8&scoped=true"
import script from "./index.js?vue&type=script&lang=js"
export * from "./index.js?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=8e3aacd8&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e3aacd8"]])

export default __exports__